import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack,
  Heading,
  Image,
  VStack,
  Text,
  RadioGroup,
  Radio,
  Button,
} from '@chakra-ui/react';

import ReceiverNodeIcon from '../../../../assets/projects/receiver_node.svg';
import { useState } from 'react';

export const RejectionReceiverNodeModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: (isRejected?: boolean) => void;
}) => {
  const [isRejected, setIsRejected] = useState(false);

  return (
    <Modal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      isCentered
    >
      <ModalOverlay />

      <ModalContent pb="4" borderRadius="md">
        <ModalHeader bg="custom_gray.5" borderTopRadius="md">
          <HStack>
            <Image src={ReceiverNodeIcon} />
            <Heading fontSize="md" fontWeight="medium" color="white">
              Receiver Node
            </Heading>
          </HStack>
          <ModalCloseButton color="white" />
        </ModalHeader>
        <ModalBody>
          <VStack as="form" align="stretch" gap="2">
            <HStack justify="space-between" align="start">
              <Text flexBasis="50%" fontWeight="semibold" fontSize="lg">
                Type of action:
              </Text>
              <RadioGroup
                colorScheme="orange"
                onChange={value => setIsRejected(value === 'Rejection')}
              >
                <VStack align="start">
                  <Radio value="Normal">Normal (to next receiver node)</Radio>
                  <Radio value="Rejection">
                    Rejection (to previous receiver node)
                  </Radio>
                </VStack>
              </RadioGroup>
            </HStack>
          </VStack>

          <HStack>
            <Button
              bg="custom_orange.2"
              _hover={{ bg: 'custom_orange.2' }}
              color="white"
              w="full"
              type="submit"
              onClick={() => onClose(isRejected)}
              mt="4"
            >
              Save
            </Button>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
